import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { QuickLink } from '../../../../../../models/quick-link';
import { Page } from '../../../../../../models/page';
import { QuickLinkSignFormData } from '../../../../../../models/quick-link-sign-form-data';
import { ApplicationStateService } from '../../../../../../services/application-state.service';
import { QuickLinkUtils } from '../../../../../../utils/quick-link-utils';
import _ from 'lodash';
import { UserDataService } from '../../../../../../services/user-data.service';
import { SidebarChangedEvent } from '../../../../../../utils/events/sidebar-changed-event';
import { DisabledFeatureModalable } from '../../../../../../models/disabled-feature-modalable';
import { PageFavorite } from '../../../../../../models/page-favorite';
import { PageFavoriteService } from '../../../../../../services/page-favorite.service';
import { ModalService } from '../../../../../../services/modal.service';
import { SidebarService } from '../../../../../../services/sidebar.service';
import { HomeworkService } from '../../../../../../services/homework.service';
import { QuickLinkService } from '../../../../../../services/quick-link.service';
import { HomeworkExercisePreviewModalable } from '../../../../../../models/homework-exercise-preview-modalable';
import { environment } from '../../../../../../../environments/environment';
import { PageService } from '../../../../../../services/page.service';
import {
    OfflineModeModalComponent
} from '../../../../pages/modal-container/offline-mode-modal/offline-mode-modal.component';
import { ChapterService } from '../../../../../../services/chapter.service';
import { TasksComponent } from '../../../../../sidebar/tasks/tasks.component';
import { CommunicationService } from '../../../../../../services/communication.service';
import { AssetPipe } from '../../../../../../pipes/asset.pipe';
import $ from 'jquery';
import { NgStyle } from '@angular/common';
import { BookFeatureService } from '../../../../../../services/book-feature.service';

@Component({
    selector: 'app-quicklink-dropdown',
    templateUrl: './quicklink-dropdown.component.html',
    styleUrls: ['./quicklink-dropdown.component.scss'],
    imports: [
        AssetPipe,
        NgStyle
    ],
    standalone: true
})
export class QuicklinkDropdownComponent implements OnInit, OnDestroy {
    @Input() quickLink: QuickLink;
    @Input() page: Page;

    @ViewChild('dropdown', { static: false }) set dropdown(content: ElementRef) {
        if (content) {
            content.nativeElement.addEventListener('hide.bs.dropdown', () => {
                this.dropdownIcon = 'icon-bookviewer-dropdown.png';
                this.dropdownShown = false;
            });
            content.nativeElement.addEventListener('show.bs.dropdown', () => {
                this.dropdownIcon = 'icon-bookviewer-dropdown-active.png';
                this.dropdownShown = true;
                this.communicationService.openQuickLinkDropdown(this.quickLink.id);

                this.quickLinkService.testQuickLinks([this.quickLink]).then(result => {
                    this.quickLink.modalData.tested = true;
                    if (result[0].found) {
                        if (this.quickLink.isSolutionLink && !result[0].showSolution) {
                            this.quickLink.modalData.err = 'Für diese Aufgabe ist leider keine Lösung vorhanden.';
                        }
                    } else {
                        this.quickLink.modalData.err = 'Der Quicklink ist leider nicht verfügbar.';
                    }
                    if (this.quickLink.solutionLink) {
                        this.quickLink.solutionLink.modalData.tested = true;
                        if (!result[0].found) {
                            this.quickLink.solutionLink.modalData.err = 'Der Quicklink ist leider nicht verfügbar.';
                        } else if (!result[0].showSolution) {
                            this.quickLink.solutionLink.modalData.err = 'Für diese Aufgabe ist leider keine Lösung vorhanden.';
                        } else {
                            this.quickLink.solutionLink.modalData.err = null;
                        }
                    }
                    if (result[0].preview) {
                        this.checkIfPreviewExists();
                    }
                });
            });
        }
    };

    wasClicked: boolean;
    isActive = false;

    formData: QuickLinkSignFormData;
    isSignable = false;
    isDeactivated: boolean;
    dropdownShown = false;
    tooltipPosition = 'bottom';
    dropdownIcon = 'icon-bookviewer-dropdown.png';

    isPageQuickLink = false;
    isHSMLink = false;
    preview: string;
    pageIndexed: boolean;

    constructor(
        public applicationStateService: ApplicationStateService,
        public pageService: PageService,
        private userDataService: UserDataService,
        private pageFavoriteService: PageFavoriteService,
        private modalService: ModalService,
        private sidebarService: SidebarService,
        private homeworkService: HomeworkService,
        private chapterService: ChapterService,
        private quicklinkService: QuickLinkService,
        private quickLinkService: QuickLinkService,
        public bookFeatureService: BookFeatureService,
        private communicationService: CommunicationService
    ) {
    }

    ngOnInit(): void {
        this.isPageQuickLink = !this.quickLink.redirect && QuickLinkUtils.isQuicklinkLeadingToAPage(
            this.quickLink.link, this.applicationStateService.bookConfig.quickLinkPrefix);
        this.isHSMLink = QuickLinkUtils.isHSMLink(this.quickLink);
        // this.applicationStateService.globalVars.disabledAssignments = ['gm1co1m1', 'gm1co1m3', 'gm1b26'];
        this.isDeactivated = _.includes(this.applicationStateService.globalVars.disabledAssignments,
            this.quickLink.slug);

        if (this.isDeactivated) {
            this.tooltipPosition = this.quickLink.position.y < 50 ? 'bottom' : 'top';
            setTimeout(() => {
                ($('[data-bs-toggle="tooltip"]') as any).tooltip();
            }, 500);
        }

        this.isSignable = this.quickLink.isSignable &&
            (
                (this.applicationStateService.bookConfig.fullESquirrelFeature && this.userDataService.isDigi4SchoolBook()) ||
                (this.applicationStateService.bookConfig.fullESquirrelFeatureBac && this.userDataService.hasBookAccessCode()) ||
                this.userDataService.isPlusFeatureAccessible()
            );

        this.pageFavoriteService.getPageFavorites().then(result => {
            this.isActive = !!_.find(result, { pageId: this.page.id, assignmentSlug: this.quickLink.slug });
        });
        this.pageIndexed = this.isPageIndexed();

        // if (!(this.quickLink.isOther() &&
        //   this.quickLink.dropdownPossition &&
        //   !this.isPageQuickLink &&
        //   (this.quickLink.position.w * this.quickLink.position.h > 5) &&
        //   this.pageIndexed &&
        //   !this.isHSMLink)) {
        //   console.log('debug');
        //   console.log(this.quickLink.type);
        //   console.log(this.quickLink.isOther());
        // }
    }

    ngOnDestroy(): void {
        if (this.dropdown?.nativeElement) {
            $(this.dropdown?.nativeElement).off('hide.bs.dropdown');
            $(this.dropdown?.nativeElement).off('show.bs.dropdown');
        }
    }

    hoverDropdown(out = false): void {
        if (this.dropdownShown) {
            return;
        }

        if (out) {
            this.dropdownIcon = 'icon-bookviewer-dropdown.png';
        } else {
            this.dropdownIcon = 'icon-bookviewer-dropdown-hover.png';
        }
    }

    updateBookmark(): void {
        if (this.isActive) {
            this.unbookmarkQuicklink();
        } else {
            this.bookmarkQuicklink();
        }
    }

    bookmarkQuicklink(): void {
        if (!this.applicationStateService.bookConfig.bookPermissions.pageFavorite.create) {
            const disabledFeatureModal = new DisabledFeatureModalable();
            disabledFeatureModal.type = ModalService.PAGE_FAVORITE;
            disabledFeatureModal.iconUrl = 'icon-lesezeichen-active.png';
            this.modalService.openModal(disabledFeatureModal);

            return;
        }

        const pageFavorite = new PageFavorite();
        pageFavorite.pageId = this.page.id;
        pageFavorite.index = this.page.index;
        pageFavorite.assignmentSlug = this.quickLink.slug;
        this.isActive = true;
        this.pageFavoriteService.createPageFavorite(pageFavorite);
    }

    unbookmarkQuicklink(): void {
        this.isActive = false;
        this.pageFavoriteService.getPageFavorites().then(result => {
            const ele: undefined | PageFavorite = _.find(result, {
                pageId: this.page.id,
                assignmentSlug: this.quickLink.slug
            });
            if (ele) {
                this.pageFavoriteService.deletePageFavorite(ele);
            }
        });
    }

    async addHomework(): Promise<void> {
        if (!this.sidebarService || !this.applicationStateService || !this.modalService) {
            throw new Error('Services are not provided');
        }

        if (this.applicationStateService.isOfflineModeEnabled) {
            this.modalService.openModal(OfflineModeModalComponent);

            return;
        }

        if (!this.checkAuthorization()) {
            return;
        }

        if (!this.homeworkService.isHomeworkEditorOpened()) {
            this.homeworkService.addHomeworkPressed();
        }

        if (this.sidebarService.activeComponent !== TasksComponent) {
            const sidebarContentComponent = TasksComponent;
            const event = new SidebarChangedEvent(true, sidebarContentComponent);
            this.sidebarService.triggerSidebarChangeEvent(event);
        }

        this.homeworkService.testGeneratorOpened = false;
        this.homeworkService.openHomeworkEditor();

        let result = null;

        await this.quickLinkService.findQuickLinks(this.quickLink.slug)
            .then(searchResult => {
                if (searchResult && Array.isArray(searchResult) && searchResult.length > 0) {
                    result = searchResult[0].quicklinksExtended.find(
                        ele => ele.prefix + ele.slug === this.quickLink.slug
                    );
                    if (result && result.related) {
                        const related = result.related.split(',');
                        related.forEach(ele => this.homeworkService.addExercise(ele));
                    }
                }
            }).catch(err => {
                console.error(err);
            });
        this.homeworkService.addExercise(this.quickLink.link, this.quickLink.pageId, result?.teaser, result?.preview);
    }

    /**
     * On click event handler
     *
     * @param $event
     * @param isSolution
     * @return {boolean}
     */
    openQuicklink($event, isSolution = false): boolean {
        this.wasClicked = true;
        const targetLink = isSolution && this.quickLink.solutionLink ? this.quickLink.solutionLink : this.quickLink;

        if (targetLink.isHSM()) {
            return this.homeworkService.openQuicklink(targetLink, this.page.id, $event);
        }

        return this.quicklinkService.openQuicklink(targetLink);
    }

    openPreviewModal(): void {
        const homeworkExercisePreviewModalable = new HomeworkExercisePreviewModalable();
        homeworkExercisePreviewModalable.type = ModalService.HOMEWORK_EXERCISE_PREVIEW;
        let prefix = this.applicationStateService.bookConfig.quickLinkPrefix;
        prefix = !this.quickLink.slug.includes(prefix) ? (this.applicationStateService.bookConfig.quickLinkPrefix || '') : '';
        homeworkExercisePreviewModalable.quicklink = prefix + this.quickLink.slug;
        homeworkExercisePreviewModalable.preview = this.preview;
        homeworkExercisePreviewModalable.teaser = '';
        homeworkExercisePreviewModalable.addingAllowed = false;

        this.modalService.openModal(homeworkExercisePreviewModalable);
    }

    isPageIndexed(): boolean {
        if (this.chapterService.getFirstChapter()) {
            // eslint-disable-next-line max-len
            return this.pageService.getRealPageNumberByPageID(this.quickLink.pageId) >= this.pageService.getRealPageNumber(this.chapterService.getFirstChapter().index);
        }

        return this.pageService.getRealPageNumberByPageID(this.quickLink.pageId) > 0;
    }

    private checkIfPreviewExists(): void {
        const img = document.createElement('img');
        const prefix = this.applicationStateService.bookConfig.quickLinkPrefix || '';
        let quicklink: string;
        if (prefix && this.quickLink.slug && this.quickLink.slug.startsWith(prefix)) {
            quicklink = this.quickLink.slug;
        } else {
            quicklink = prefix + this.quickLink.slug;
        }

        img.src = environment.externalUrls.preview(quicklink);
        img.onload = () => {
            this.preview = environment.externalUrls.preview(
                quicklink
            );
        };
    }

    private checkAuthorization(): boolean {
        if (!this.sidebarService.wasHSMOpened() &&
            !this.applicationStateService.bookConfig.bookPermissions.homework.create) {
            this.modalService.openDisabledHSMModal();

            return false;
        }

        return true;
    }
}
